import { render } from "./DistributorProductsView.vue?vue&type=template&id=ec2e3cc4"
import script from "./DistributorProductsView.vue?vue&type=script&lang=js"
export * from "./DistributorProductsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__